import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PageHero from '../../shared/components/PageHero/PageHero';


class HomepageHero extends Component {
  static getDomId() {
    return 'slot_homepage_hero';
  }

  render() {
    return (<PageHero {...this.props} />);
  }
}

HomepageHero.defaultProps = {
  linkTo: '',
  imageUrl: '',
  buttonText: '',
  shortDescription: '',
  markdownDescription: '',
  bannerTemplate: 'clickableImage',
};
HomepageHero.propTypes = {
  linkTo: PropTypes.string,
  imageUrl: PropTypes.string,
  buttonText: PropTypes.string,
  bannerTemplate: PropTypes.string,
  shortDescription: PropTypes.string,
  markdownDescription: PropTypes.string,
  title: PropTypes.string.isRequired,
  external: PropTypes.bool.isRequired,
};

export default HomepageHero;
